var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button, FormModal, RightDiv, Separator, Form } from "@atlassiansox/microscopekit";
import SectionMessage from "@atlaskit/section-message";
import { ButtonGroup } from "@atlaskit/button";
import { FaultsManager, SteadyStatesManager } from "./TaskGroups";
import { DynamicFormField } from "./common";
import { validators } from "../../utils";
export var TaskGroupFormFc = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = __read(useState((_b = (_a = props.taskGroup) === null || _a === void 0 ? void 0 : _a.steadyStates) !== null && _b !== void 0 ? _b : []), 2), newSteadyStates = _g[0], setNewSteadyStates = _g[1];
    var _h = __read(useState((_d = (_c = props.taskGroup) === null || _c === void 0 ? void 0 : _c.faults) !== null && _d !== void 0 ? _d : []), 2), newFaultInputs = _h[0], setNewFaultInputs = _h[1];
    var _j = __read(useState((_f = (_e = props.taskGroup) === null || _e === void 0 ? void 0 : _e.delayBeforeExecution) !== null && _f !== void 0 ? _f : 150), 2), delayBeforeExecution = _j[0], setDelayBeforeExecution = _j[1];
    var _k = __read(useState(false), 2), isConfirmationModelOpen = _k[0], setIsConfirmationModelOpen = _k[1];
    var isDelayBeforeExecutionEnabled = props.taskGroupIndex !== 0;
    var saveTaskGroup = function () {
        props.addTaskGroup(__assign({ steadyStates: newSteadyStates, faults: newFaultInputs }, (isDelayBeforeExecutionEnabled && {
            delayBeforeExecution: delayBeforeExecution
        })));
        // reset the stop conditions, fault inputs
        setNewSteadyStates([]);
        setNewFaultInputs([]);
    };
    var cancelTaskGroupEdit = function () {
        props.cancelTaskGroupEdit();
        // reset the stop conditions, fault inputs
        setNewSteadyStates([]);
        setNewFaultInputs([]);
    };
    useEffect(function () {
        var _a, _b, _c, _d;
        setNewSteadyStates((_b = (_a = props.taskGroup) === null || _a === void 0 ? void 0 : _a.steadyStates) !== null && _b !== void 0 ? _b : []);
        setNewFaultInputs((_d = (_c = props.taskGroup) === null || _c === void 0 ? void 0 : _c.faults) !== null && _d !== void 0 ? _d : []);
    }, [props.taskGroup]);
    return (React.createElement("div", null,
        React.createElement(FormModal, { isOpen: isConfirmationModelOpen, actions: {
                submit: {
                    text: "Save",
                    onSubmit: function (data) {
                        setIsConfirmationModelOpen(false);
                        setNewSteadyStates([]);
                        setNewFaultInputs([]);
                        return new Promise(function (resolve, reject) {
                            saveTaskGroup();
                        });
                    }
                },
                close: {
                    text: "Cancel",
                    onClose: function () {
                        setIsConfirmationModelOpen(false);
                    }
                }
            } },
            React.createElement(SectionMessage, { title: "Warning", appearance: "warning" }, "You haven't added stop condition. In absence of stop condition, experiment rollback step is based on fault duration or user abort")),
        React.createElement("h4", null, "New Task Group"),
        isDelayBeforeExecutionEnabled && (React.createElement(DelayBeforeExecutionContainer, null,
            React.createElement(Form, { onSubmit: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/];
                }); }); } },
                React.createElement(DynamicFormField, { name: "delayBeforeExecution", label: "Delay Before Execution(in seconds)", labelHelperText: "Delay before start of execution of faults in this task group. Cannot be less than 150.", type: "number", isRequired: true, value: delayBeforeExecution, onChange: setDelayBeforeExecution, validate: function (value) { return validators.min(value, 150); } })),
            React.createElement("br", null))),
        React.createElement(FaultsManager, { value: newFaultInputs, onChange: setNewFaultInputs, containersForService: props.containersForService, microsGroupsForService: props.microsGroupsForService, serviceId: props.serviceId, environment: props.environment }),
        React.createElement(Separator, null),
        React.createElement(SteadyStatesManager, { value: newSteadyStates, onChange: setNewSteadyStates }),
        React.createElement(RightDiv, null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { appearance: "subtle", onClick: cancelTaskGroupEdit }, "Cancel"),
                React.createElement(Button, { appearance: "primary", onClick: function () {
                        if (newSteadyStates.length === 0) {
                            setIsConfirmationModelOpen(true);
                        }
                        else {
                            saveTaskGroup();
                        }
                    }, disabled: newFaultInputs.length === 0 }, "Save Task Group")))));
};
var DelayBeforeExecutionContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 40%;\n  margin-left: 0.5rem;\n"], ["\n  width: 40%;\n  margin-left: 0.5rem;\n"])));
var templateObject_1;
